module.exports = __webpack_public_path__ + "static/media/folder-open.c52919c1.svg";